<template>
  <div class="audit-selection-container">
    <div class="audit-item" v-for="(plan, index) in audits" :key="index">
      <AuditSelectionItem
        :plan="plan"
        :selected="selected === plan.internalId"
        :auditDeadline="auditDeadlines[plan._id]"
        @audit-selected="selectAudit"
        @audit-unselected="unselectAudit"
        @audit-deadline-changed="changeDeadline"
        :bus="bus"
      />
    </div>
  </div>
</template>

<script>
import AuditSelectionItem from '@/components/Administrator/Lists/AuditSelectionItem.vue'

export default {
  name: 'AuditSelection',
  components: { AuditSelectionItem },
  props: ['audits', 'auditDeadlines', 'selected', 'bus'],
  methods: {
    selectAudit(planId) {
      this.$emit('audit-selected', planId)
    },
    unselectAudit(planId) {
      this.$emit('audit-unselected', planId)
    },
    changeDeadline(deadline) {
      this.$emit('audit-deadline-changed', deadline)
    }
  },
  beforeMount() {
    console.log('Created hook')
    this.bus.$on('reset-active-item-status', planId => {
      this.bus.$emit('reset', planId)
    })
  }
}
</script>
